import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar is-fixed-bottom" }
const _hoisted_2 = { class: "navbar-item" }
const _hoisted_3 = { class: "is-flex is-justify-content-space-between" }
const _hoisted_4 = { class: "control" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-drum" })
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Beräkna splitten", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, " Totalen: $" + _toDisplayString(_ctx.totalAmount), 1),
        _createElementVNode("p", _hoisted_4, [
          _createElementVNode("a", {
            class: "button is-primary",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.calculateSplit && _ctx.calculateSplit(...args)))
          }, _hoisted_7)
        ])
      ])
    ])
  ]))
}